export default __webpack_public_path__ + "static/media/digital-agency-contact-image-01.9450262e.jpg";